<template>
  <div class="information">
    <div class="info-container">
      <div class="info-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-text" :to="{ path: '/index/' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item
            class="breadcrumb-text"
            :to="{ path: '/adminuser/' }"
            >用户管理</el-breadcrumb-item
          >
          <el-breadcrumb-item class="breadcrumb-text"
            >新增平台管理员</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="data-info">
        <div class="info-operate">
          <el-button type="primary" @click="submitUpload">保存</el-button>
          <!-- <el-button type="danger">删除</el-button> -->
        </div>
        <el-card style="margin-top: 20px">
          <div
            style="
              font-size: 20px;
              font-weight: 700;
              color: #2658ea;
              text-align: left;
            "
          >
            新增平台管理员
          </div>
          <el-row :gutter="24" style="margin-top: 20px">
            <el-col :span="6">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <div style="margin-bottom: 10px">账号</div>
                <el-input v-model="username"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <div style="margin-bottom: 10px">密码</div>
                <el-input v-model="password"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <div style="margin-bottom: 10px">姓名</div>
                <el-input v-model="name"></el-input>
              </div>
            </el-col>
          </el-row>
          <div class="per-container" v-if="permissionData.length > 0">
            <div style="margin-bottom: 20px">平台管理员权限</div>
            <div class="choose_box">
              <div>
                <el-checkbox
                  @change="allCheck"
                  v-model="isallCheck"
                  :indeterminate="isIndeterminate"
                  label="全选"
                ></el-checkbox>
              </div>
            </div>

            <div v-for="(item, index) in permissionData" :key="index">
              <el-checkbox
                style="margin-top: 20px; display: flex; align-items: flex-start"
                :indeterminate="item.isIndeterminate"
                v-model="item.isCheck"
                @change="handleCheckAllChange(item.isCheck, index)"
                >{{ item.name }}
              </el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="item.checkedData"
                @change="handleCheckedCitiesChange(item.checkedData, index)"
              >
                <el-checkbox
                  v-for="(pitem, index) in item.perlist"
                  :label="pitem.id"
                  :key="index"
                >
                  {{ pitem.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddManage",
  components: {},
  data() {
    return {
      username: "",
      password: "",
      name: "",
      permissionData: [], // 权限
      isallCheck: false, // 最外层全选
      isIndeterminate: false, // 最外层全选
    };
  },
  created() {
    this.clubid = this.$route.query.clubid;
    this.requestData();
  },
  mounted() {},
  methods: {
    // 保存 新增Banner
    submitUpload() {
      let formdata = new FormData();
      if (!this.username) {
        this.$message.error("请输入账号");
        return false;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return false;
      }
      if (!this.name) {
        this.$message.error("请输入姓名");
        return false;
      }

      let permissionData = this.permissionData;
      let perIds = [];
      for (let i = 0; i < permissionData.length; i++) {
        if (permissionData[i].isCheck) {
          perIds.push(permissionData[i].id);
          for (let j = 0; j < permissionData[i].checkedData.length; j++) {
            perIds.push(permissionData[i].checkedData[j]);
          }
        } else {
          for (let j = 0; j < permissionData[i].checkedData.length; j++) {
            perIds.push(permissionData[i].checkedData[j]);
          }
          if (permissionData[i].checkedData.length > 0) {
            perIds.push(permissionData[i].id);
          }
        }
      }

      formdata.set("username", this.username);
      formdata.set("password", this.password);
      formdata.set("name", this.name);
      formdata.set("perIds", JSON.stringify(perIds));
      this.$axios({
        url: "/backend/admin_create/",
        method: "post",
        data: formdata,
      })
        .then((res) => {
          if (res.data.success) {
            this.$message.success("保存成功");
            this.$router.push({
              path: "/adminuser/",
            });
          } else {
            this.$message.error(res.data.error);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // 请求权限
    requestData() {
      this.$axios({
        url: "/backend/permission_query/",
        methods: "get",
        params: {
          action: "admin",
        },
      })
        .then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              for (var i = 0; i < res.data.data.length; i++) {
                let checkedData = [];
                this.$set(res.data.data[i], "isCheck", false);
                this.$set(res.data.data[i], "isIndeterminate", true);
                let have = 0;
                for (var j = 0; j < res.data.data[i].perlist.length; j++) {
                  if (res.data.data[i].perlist[j].is_have) {
                    have++;
                    checkedData.push(res.data.data[i].perlist[j].id);
                  }
                }
                if (parseInt(have) == res.data.data[i].perlist.length) {
                  this.$set(res.data.data[i], "isCheck", true);
                  this.$set(res.data.data[i], "isIndeterminate", false);
                  this.isallCheck = true;
                  this.isIndeterminate = false;
                } else {
                  this.isallCheck = false;
                  this.$set(res.data.data[i], "isIndeterminate", false);
                }
                this.$set(res.data.data[i], "checkedData", checkedData);
              }
            }
            this.permissionData = res.data.data;
          } else {
            this.$message.error(res.data.error);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // all 全选
    allCheck(val) {
      let permissionData = this.permissionData;
      if (val) {
        for (var i = 0; i < permissionData.length; i++) {
          // permissionData[i].isCheck = true
          this.$set(permissionData[i], "isCheck", true);
          let arr = [];
          for (let j = 0; j < permissionData[i].perlist.length; j++) {
            arr[j] = permissionData[i].perlist[j].id;
          }
          this.$set(permissionData[i], "checkedData", arr);
          this.$set(permissionData[i], "isIndeterminate", false);
        }
      } else {
        for (var i = 0; i < permissionData.length; i++) {
          // permissionData[i].isCheck = true
          this.$set(permissionData[i], "isCheck", false);
          let arr = [];
          this.$set(permissionData[i], "checkedData", arr);
          this.$set(permissionData[i], "isIndeterminate", false);
        }
      }
      this.permissionData = permissionData;
    },

    handleCheckAllChange(val, index) {
      // 全选 val 是否全选
      let arr = [];
      const re = this.permissionData[index].perlist;
      //全选
      if (val) {
        for (let i = 0; i < re.length; i++) {
          arr[i] = re[i]["id"];
        }
      }
      // this.permissionData[index].checkedData = arr;
      // this.permissionData[index].isIndeterminate = false;
      this.$set(this.permissionData[index], "checkedData", arr);
      this.$set(this.permissionData[index], "isIndeterminate", false);

      let permissionData = this.permissionData;
      let have = 0;
      for (var i = 0; i < permissionData.length; i++) {
        if (permissionData[i].isCheck) {
          have++;
        }
      }
      if (parseInt(have) == permissionData.length) {
        this.isallCheck = true;
        this.isIndeterminate = false;
      } else {
        this.isallCheck = false;
        this.isIndeterminate = true;
      }
    },

    handleCheckedCitiesChange(val, index) {
      let checkedCount = val.length;
      // this.permissionData[index].isCheck =
      //   checkedCount === this.permissionData[index].perlist.length;

      // this.permissionData[index].isIndeterminate =
      //   checkedCount > 0 && checkedCount < this.permissionData[index].perlist.length;

      this.$set(
        this.permissionData[index],
        "isCheck",
        checkedCount === this.permissionData[index].perlist.length
      );
      this.$set(
        this.permissionData[index],
        "isIndeterminate",
        checkedCount > 0 &&
          checkedCount < this.permissionData[index].perlist.length
      );
      let permissionData = this.permissionData;
      let have = 0;
      for (var i = 0; i < permissionData.length; i++) {
        if (permissionData[i].isCheck) {
          have++;
        }
      }
      if (parseInt(have) == permissionData.length) {
        this.isallCheck = true;
        this.isIndeterminate = false;
      } else {
        this.isallCheck = false;
        this.isIndeterminate = true;
      }
    },
  },
};
</script>


<style lang="less" scoped>
.information {
  background: url("/login/bg2.jpg") no-repeat;
  background-size: 100% 100%;
  height: 100%;
  min-height: 100vh;
  .info-container {
    margin: 0 auto;
    width: 75vw;
    padding: 10vh 0;
    box-sizing: border-box;

    .info-tab {
      margin-top: 40px;
    }
    .info-table {
      margin-top: 30px;
    }
  }
}

.isshowimg /deep/ .el-upload {
  display: none;
}

// 背景框大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: unset;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  margin: 0 10px 0 0;
}

.breadcrumb-text /deep/ .el-breadcrumb__inner {
  color: #000000;
  font-size: 16px;
  background: #fff;
  padding: 5px 15px;
  box-sizing: border-box;
  border-radius: 5px;
}

.data-info {
  margin-top: 30px;
}

.info-operate {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.el-card {
  // height: 70vh;
}

.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.el-col-6 {
  margin-bottom: 20px;
}

.bg-purple {
  background: #fff;
  border: 1px solid #c9c9c9;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

// .el-input /deep/ .el-input__inner {
//   border: none;
// }

.el-input.is-disabled /deep/ .el-input__inner {
  background: #fff;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<style lang="less">
.tab-self /deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
}

.tab-self .el-tabs__item {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.el-table--enable-row-transition {
  border-radius: 5px !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #2658ea;
}

.tab-self .el-tabs__item {
  border-bottom: 1px solid #e4e7ed !important;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.tab-self .el-tabs__item:hover {
  // color: #2658EA;
  color: #fff;
}

.tab-self .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}

// 底部分页
.info-pagination {
  margin-top: 40px;
}

// 分页默认样式
.el-pagination {
  display: flex;
  padding: unset !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li:first-child {
  margin-left: unset !important;
}
</style>